import React from 'react';
import { Input, Typography } from '@crisellevaldez/speculo-ui';
import { UseFormRegisterReturn } from 'react-hook-form';

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  registration: Partial<UseFormRegisterReturn>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  registration,
  startIcon,
  endIcon,
  ...props
}) => {
  return (
    <div className="space-y-2">
      <Typography variant="p" className="text-sm font-medium text-gray-700">
        {label}
      </Typography>
      <Input {...registration} {...props} startIcon={startIcon} endIcon={endIcon} />
      {error && (
        <Typography variant="p" className="text-sm text-red-600">
          {error}
        </Typography>
      )}
    </div>
  );
};
